import PieChart from '../../components/pie-chart/PieChart';
import { InternalCommentStatistics } from '../../types/internal-comment';

type InternalCommentsChartProps = {
    progress: InternalCommentStatistics;
};

function InternalCommentsChart({ progress }: InternalCommentsChartProps): JSX.Element {
    const total = progress.resolved + progress.active;
    const percentComplete = total === 0 ? 100 : Math.floor((progress.resolved / total) * 100);

    const slices = [
        {
            legend: `${progress.resolved} Resolved`,
            color: percentComplete === 100 ? '#16a34a' : '#6366f1',
            count: progress.resolved,
            percent: total === 0 ? 100 : Math.floor((progress.resolved / total) * 100),
            title: 'Resolved',
        },

        {
            legend: `${progress.active} Active`,
            color: percentComplete === 100 ? '#16a34a' : '#e5e7eb',
            count: progress.active,
            percent: total === 0 ? 0 : Math.floor((progress.active / total) * 100),
            title: 'Active',
        },
    ];

    return (
        <div className="rounded-md w-fit p-6">
            <PieChart title="Internal Comments" figure={Math.floor(percentComplete)} slices={slices} />
        </div>
    );
}

export default InternalCommentsChart;
